(function () {
  'use strict';

  if (document.documentElement.classList.contains('diva-performance-loaded')) return;
  document.documentElement.classList.add('diva-performance-loaded');

  var pending = [];

  function schedule(task) {
    pending.push(task);
    if (pending.length !== 1) return;
    window.requestAnimationFrame(function () {
      var tasks = pending.slice();
      pending.length = 0;
      tasks.forEach(function (item) {
        try { item(); } catch (error) {}
      });
    });
  }

  window.DivaPerf = window.DivaPerf || {};
  window.DivaPerf.toggleClass = function (element, className, force) {
    if (!element) return;
    schedule(function () {
      if (typeof force === 'boolean') element.classList.toggle(className, force);
      else element.classList.toggle(className);
    });
  };

  function loadDeferredImage(image) {
    var source = image.getAttribute('data-src');
    if (!source) return;
    image.src = source;
    image.removeAttribute('data-src');
  }

  function initializeDeferredImages() {
    var images = document.querySelectorAll('img.diva-lazy-image[data-src]');
    if (!images.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(images, loadDeferredImage);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadDeferredImage(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '240px 0px' });
    Array.prototype.forEach.call(images, function (image) { observer.observe(image); });
  }

  function optimizePriorityMedia() {
    var main = document.querySelector('main');
    if (!main) return;
    var images = main.querySelectorAll('img:not([data-src]):not([data-srcset])');
    var priorityImage = main.querySelector('img[fetchpriority="high"], .dvpp-main img, .divarouj-hero img, .t4s-slideshow img');

    Array.prototype.forEach.call(images, function (image, index) {
      if (!image.hasAttribute('decoding')) image.setAttribute('decoding', 'async');
      if (image === priorityImage) {
        image.setAttribute('loading', 'eager');
        image.setAttribute('fetchpriority', 'high');
      } else if (!image.hasAttribute('loading') && index > 1) {
        image.setAttribute('loading', 'lazy');
      }
    });
  }

  function optimizeBelowFoldMedia() {
    var main = document.querySelector('main');
    if (!main) return;
    Array.prototype.forEach.call(main.querySelectorAll('iframe:not([loading])'), function (frame) {
      frame.setAttribute('loading', 'lazy');
    });
    Array.prototype.forEach.call(main.querySelectorAll('video:not([preload])'), function (video) {
      video.setAttribute('preload', 'metadata');
    });
  }

  function boot() {
    initializeDeferredImages();
    optimizePriorityMedia();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(optimizeBelowFoldMedia, { timeout: 1500 });
    } else {
      window.setTimeout(optimizeBelowFoldMedia, 600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

